/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// QAS Address Search
export const getQasAddressSuggestions = (state) => state.mfeCheckout?.addressQAS?.suggestions;
export const getQasSearchFormattedAddress = (state) => state.mfeCheckout?.addressQAS?.formatAddress;
export const getShowValidatedAddress = (state) => state.mfeCheckout?.addressQAS?.showValidatedAddress;
export const getHasQasFailedCheckout = (state) => state.mfeCheckout?.addressQAS?.qasFailed || false;
export const getUnverifiedFlowActive = (state) => state.mfeCheckout?.addressQAS?.isUnverifiedFlowActive || false;

export default {};
